"use client";

import { c as _c } from "react/compiler-runtime";
import { LOGO_STRIP_CAPTION, LOGOS, STATS } from "@/constants";
import { useCounterAnimation } from "@/hooks";
export default function LogoMarqueeSection() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...LOGOS, ...LOGOS];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const repeated = t0;
  const {
    counterValues
  } = useCounterAnimation();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-[var(--text)]">{LOGO_STRIP_CAPTION}</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="space-y-10">{t1}<div className="logo-marquee-mask overflow-hidden mb-4"><div className="logo-marquee">{repeated.map(_temp)}</div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== counterValues) {
    t3 = STATS.map((item, index) => <div key={item.label} className="p-5 space-y-3 text-center"><p className="mt-3 text-4xl font-semibold text-[var(--accent)]">{counterValues[index]}{item.suffix}</p><p className="text-xs uppercase tracking-[0.2em] text-[var(--text)]">{item.label}</p></div>);
    $[3] = counterValues;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="reveal-section full-bleed space-y-6 bg-[#040a2e]/60 py-10">{t2}<section id="stats-section" className="reveal-section grid gap-4 rounded-2xl border-t mt-10 border-[var(--stroke)] p-6 md:grid-cols-4">{t3}</section></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp(logo, idx) {
  return <span key={`${logo}-${idx}`} className="shrink-0 px-10 text-2xl font-medium tracking-wide text-[var(--subtle)] transition hover:text-[var(--text)]">{logo}</span>;
}